import { useAuth } from "@/_core/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, RefreshCw } from "lucide-react";
import SystemStatusCards from "@/components/SystemStatusCards";
import { trpc } from "@/lib/trpc";

export default function SystemStatus() {
  const { user, loading: authLoading } = useAuth();

  const { data: healthData, isLoading: healthLoading, refetch } = trpc.system.getStatusSummary.useQuery(undefined, {
    refetchInterval: 30000, // Auto-refresh every 30 seconds
  });

  if (authLoading || healthLoading) {
    return (
      <div className="container max-w-6xl py-8">
        <div className="flex items-center justify-center min-h-[400px]">
          <RefreshCw className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="container max-w-6xl py-8">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Authentication required. Please log in to access system status.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  if (user.role !== 'admin' && user.role !== 'supervisor') {
    return (
      <div className="container max-w-6xl py-8">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Insufficient permissions. Only supervisors and admins can access system status.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container max-w-6xl py-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold">System Status</h1>
          <p className="text-muted-foreground mt-1">
            Monitor core system health and connectivity
          </p>
        </div>
        <Button onClick={() => refetch()} variant="outline" size="sm">
          <RefreshCw className="h-4 w-4 mr-2" />
          Refresh
        </Button>
      </div>

      <SystemStatusCards healthData={healthData} isLoading={healthLoading} />
    </div>
  );
}
